var map = {
	"./All Data.png": 7869,
	"./NoData.png": 4130,
	"./Repotees+My Data.png": 6049,
	"./Repotees+My-Data.png": 6016,
	"./RepoteesData.png": 5722,
	"./mydata.png": 1234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4111;